// src/components/popups/ConfirmRevealCodeDrawer.js
import React from 'react';
import './ConfirmRevealCodeDrawer.css';

export default function ConfirmRevealCodeDrawer({
  open,
  onCancel,
  onConfirm,
}) {
  if (!open) return null;

  return (
    <div className="confirm-reveal-backdrop" onClick={onCancel}>
      <div
        className="confirm-reveal-drawer"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirm-reveal-title">
          Reveal Reward Code?
        </div>

        <div className="confirm-reveal-text">
          Once you reveal this reward code, it will be permanently marked as
          revealed.
          <br /><br />
          Revealed codes <b>cannot be sold or transferred</b> in the marketplace.
          <br /><br />
          Only continue if you are sure you want to redeem this code yourself.
        </div>

        <div className="confirm-reveal-actions">
          <button className="rcode-btn" onClick={onCancel}>
            Cancel
          </button>

          <button
            className="rcode-btn danger"
            onClick={onConfirm}
          >
            Reveal Code
          </button>
        </div>
      </div>
    </div>
  );
}
